import * as ReactService from "@intech/react-service";
import { AvaliacaoTextoEntidade } from "../entidades/AvaliacaoTextoEntidade";
import { AvaliacaoEntidade } from "../entidades/AvaliacaoEntidade";

class Avaliacao extends ReactService.BaseService {
  constructor() {
    super("Avaliacao");
  }

  BuscarTexto = (numFuncionalidade: number) =>
    this.CreateRequest<AvaliacaoTextoEntidade>(ReactService.RequestType.GET, `BuscarTexto/${numFuncionalidade}`);

  Enviar = (avaliacao: AvaliacaoEntidade) =>
    this.CreateRequest<any>(ReactService.RequestType.POST, `Enviar`, avaliacao);

}

export const AvaliacaoService = new Avaliacao();
